import { Component,OnInit, Input, Output,EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'modal-discard',
  templateUrl: './modal-object.component.html',
  styleUrls: ['./modal-object.component.scss']
})
export class ModalObjectComponent implements OnInit, OnChanges {
  @Input() theme: string = "silver";
  @Input() isMobile:boolean = false;
  @Output() onModalButtonsClick: EventEmitter<string> = new EventEmitter();

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["theme"]){
      this.theme = changes["theme"].currentValue;
    }

    if (changes && changes["isMobile"]){
      this.isMobile = changes["isMobile"].currentValue;
    }
  }

  /* EVENTS */
  onApplyModalClick(){
    this.onModalButtonsClick.emit('apply');
  }

  onDiscardModalClick(){
    this.onModalButtonsClick.emit('discard');
  }

  onCloseModalClick(){
    this.onModalButtonsClick.emit('cancel');
  }
}
